import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading3, Input } from '@cian/ui-kit';

import { IconActionCopy16 } from '@cian/ui-kit-design-tokens/icons';

export interface IDesktopViewProps {
  url: string;
  onClick(): void;
  isVisibleClipboard: boolean;
  onFocus?(): void;
}

export const DesktopView: React.FC<IDesktopViewProps> = ({ url, isVisibleClipboard, onClick, onFocus }) => {
  return (
    <div data-testid="DesktopViewId" className={styles['content']}>
      <div className={styles['text-content']}>
        <ArticleHeading3>Отлично! Отчет доступен по ссылке</ArticleHeading3>
      </div>
      <div className={styles['input']}>
        <Input
          data-testid="input-url-report"
          value={url}
          size="M"
          onFocus={onFocus}
          rightAdornment={
            isVisibleClipboard ? (
              <button
                data-testid="Desktop-share-report"
                type="button"
                className={styles['copy-button']}
                onClick={onClick}
              >
                <IconActionCopy16 color="icon-main-default" />
              </button>
            ) : null
          }
        />
      </div>
    </div>
  );
};

DesktopView.displayName = 'DesktopView';
